import { ErrorDetail } from './types';

/**
 * Формирует строку из массива с деталями ошибки.
 *
 * @param detail - Массив, содержащий информацию об ошибке.
 * @returns  Строка, составленная из ошибок.
 */
export const getErrorDetailsText = (details?: ErrorDetail[]): string => {
	if (!details?.length) {
		return '';
	}

	return details.map(detail => `${detail.label}: ${detail.value}`).join(', ');
};
